import { LunaTabName } from "@/types";

import { LunaTabs } from "../features";

import { TabContent } from "./Tabs";

interface Props {
  activeTab: LunaTabName;
  setActiveTab: (tab: LunaTabName) => void;
  inRecordedLessonView: boolean;
  isVisible: boolean;
}

const Luna = ({
  activeTab,
  setActiveTab,
  inRecordedLessonView,
  isVisible,
}: Props) => {
  return (
    <div
      className={`flex flex-col h-full px-4 ${!isVisible ? "hidden" : "flex"}`}
    >
      <div>
        <LunaTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      <div className="flex-1 min-h-0">
        <TabContent
          activeTab={activeTab}
          inRecordedLessonView={inRecordedLessonView}
        />
      </div>
    </div>
  );
};

export default Luna;
